import { t } from 'i18next';
import { UnitStatus, UnitStatusKey } from 'providers/types/unit';
import { Profile } from './userProfile';

export function handleUnitStatusString(production: string): string {
  switch (production) {
    case UnitStatus.INSTALLATION: return t('emInstalacao');
    case UnitStatus.OPERATION: return t('emOperacao');
    case UnitStatus.MODERNIZATION: return t('emModernizacao');
    case UnitStatus.FORCED_UNINSTALL: return t('desinstalacaoForcada');
    default: throw new Error('Unit status not found');
  }
}

export function handleUnitStatusByProfile(profile: Profile): UnitStatusKey[] {
  const unitStatus: UnitStatusKey[] = ['OPERATION', 'MODERNIZATION', 'FORCED_UNINSTALL'];

  if (profile.manageAllClients) {
    unitStatus.push('INSTALLATION');
  }

  return unitStatus;
}
